import React, { PureComponent } from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import './project-info.css';
import { DefaultButton, PrimaryButton, Dropdown } from 'office-ui-fabric-react';
import connect from 'react-redux/es/connect/connect';
import {
  toggleProjectsCrudModal,
  getStateToPersist,
  restorePersistedState,
} from '../../../actions/project-crud-actions';
import {
  setProjectInfo,
  setCurrentProject,
  setProjectStatus,
  runSaveProjectAction,
} from '../../../actions/project-actions';
import { showProjectsAdminMultibedWarning, toggleProjectsAdminModal } from '../../../actions/projects-admin-action';
import Project from '../../../lib/project';
import cuid from 'cuid';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { toast } from 'react-toastify';
import BlockUi from 'react-block-ui';
import {
  states,
  CAProvinces,
  MXProvinces,
  buildProjectAutomation,
  buildPipeProjectAutomation,
} from '../../../actions/submit-dialog-actions';
import { regionIds } from '../../../lib/localization/regionIds';
import { DialogContent } from 'office-ui-fabric-react/lib-commonjs/Dialog';
import { clearRulersOnScreen } from '../../../actions/drawingtoolbar-actions';
import { modalAlertActions } from '../../../actions/modal-alert.actions';
import MiniCADAPI from '../../../lib/MiniCADAPI';
import produce from 'immer';
import MultibedSelectors from '../../../reducers/multi-bed-reducer';
import SubProjectService from '../../../lib/services/sub-project-service';
import MultiBedService from '../../../lib/services/multibed-service';
import {
  setDirtyStateForMultiBeds,
  setMultiBedOtherUserData,
  setSelectedBed,
  updateBedForSaveAs,
  updatedSelectedBedValues,
  updatePlaceholder,
} from '../../../actions/multi-bed-actions';
import {
  getSubProjectStateToPersist,
  restoreSubProjectPersistedState,
} from '../../../actions/sub-project-crud-actions';
import { getScaledValue } from '../../../actions/calculations-actions';
import { clearViewPort, setCurrentSubProject } from '../../../actions/sub-project-actions';
import { clearMainManifoldsState } from '../../../actions/manifold-actions';
import ProjectService from '../../../lib/services/project-service';
import { getStagePosition, getStageScale, positionStage, scaleStage } from '../../../actions/viewport-actions';
import { resetAppState, switchCreateDialogVisibility } from '../../../actions/apptoolbar-actions';
import MiniCADAPI_SEARCH from '../../../lib/MiniCADAPI_SEARCH';
import { setDisableLayerLoginDialog } from '../../../actions/generic-globals.actions';

/* the seconds to check for status */
const CHECK_STATUS_INTERVAL = 15000;

const SAVE_AS = {
  CURRENT: 'CURRENT',
  COPY: 'COPY',
};

class ProjectInfoComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isSavingProject: false,
      hideDialog: true,
      hideRequiredFieldsDialog: true,
      contentProps: {
        type: DialogType.normal,
        title: this.props.content[this.props.lang].saveCurrentDefault,
        subText: this.props.content[this.props.lang].stateSavedDefault,
      },
      modalProps: {
        titleAriaId: 'myLabelId',
        subtitleAriaId: 'mySubTextId',
        isBlocking: true,
        containerClassName: 'ms-dialogMainOverride',
      },
      requiredFieldsModalProps: {
        titleAriaId: 'myLabelId',
        subtitleAriaId: 'mySubTextId',
        isBlocking: false,
        containerClassName: 'ms-dialogMainOverride',
      },
      saveAs: SAVE_AS.COPY,
      dialogConfirmText: 'Save',
      showIsoRowPlusWarning: false,
      showBarracudaDialog: false,
      creatingSave: false,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.runSaveProject) {
      this.props.runSaveProjectAction(false);
      this.promptSaveAsCurrentDialog();
    }
  }

  /**
   * Returns the appropriate status based on project
   * @param status {Undefined | String}
   * @returns {boolean}
   */
  processingStatusIsWritable(status) {
    return (
      !status ||
      status === Project.PROCESSING_STATUS.unsubmitted ||
      status === Project.PROCESSING_STATUS.success ||
      status === Project.PROCESSING_STATUS.failed ||
      status === Project.PROCESSING_STATUS.copied
    );
  }

  componentDidMount() {
    setInterval(async () => {
      if (this.props.project && !this.processingStatusIsWritable(this.props.project.processingStatus)) {
        let status = Project.PROCESSING_STATUS.pending;
        if (!this.props.project.isMultiBedProject) {
          let pr = ProjectService.getNewProjectInstance(this.props.project);
          status = await pr.checkWorkItemStatus(this.props.user.id);
        } else {
          let pr = ProjectService.getNewProjectInstance(this.props.project);
          status = await pr.checkWorkItemStatus(this.props.user.id);
        }

        if (status === 'failedDownload') status = 'failed';

        if (status !== this.props.project.processingStatus) {
          if (status.includes('fail')) status = Project.PROCESSING_STATUS.failed;

          let project_instance = ProjectService.getNewProjectInstance(this.props.project);

          let prj = await project_instance.fetch(
            this.props.user.id,
            this.props.resourcesTokens.projects['tableToken'],
          );

          this.props.setCurrentProject(prj);

          if (status !== Project.PROCESSING_STATUS.success) {
            toast.error(this.props.content[this.props.lang]['somethingWentWrongEmail'], {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
          } else {
            toast.success(this.props.content[this.props.lang]['projectDrawingsDelivered'], {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 5000,
            });
          }
        }
      }
    }, CHECK_STATUS_INTERVAL);
  }

  async putCurrentRecord() {
    // the project object, if an instance(persisted is present), otherwise
    //use the unsaved project info
    const isFirstSave = !this.props.project;
    let project = this.props.project || this.props.projectInfo;

    // Checks if the project owner loaded the project,
    // if not the owner it will override the user id and same a new project
    if (this.props.multiBed.otherUserId && this.props.multiBed.otherUserId !== null) {
      let tmpProject = { ...project };
      tmpProject.id = cuid();
      tmpProject.processingStatus = Project.PROCESSING_STATUS.copied;
    }

    const showIsoRowPlusWarning = [regionIds.usa, regionIds.canada].indexOf(this.props.region.id) === -1;

    try {
      let projectName = project.projectName;
      let projectId = project.id || cuid();
      let boomFileUrl = project.bomFileUrl || '';
      let inputFileURL = project.inputFileURL || '';
      let outputFileURL = project.outputFileURL || '';
      let processingStatus = project.processingStatus || Project.PROCESSING_STATUS.unsubmitted;
      let createdDate = project.createdDate || new Date();
      // Save current subproject as needed on multibed
      if (project && project.isMultiBedProject) {
        if (!this.props.multiBed.otherUserId && this.props.multiBed.otherUserId === null) {
          const supProjectState = this.props.subProject;
          let currentTabObject = MultibedSelectors.getBedById(supProjectState.subProject.id);
          const subProjectId = currentTabObject.id;
          const config = { bedName: currentTabObject.name };
          let currentPlaceholderObj = MultiBedService.getPlaceholderSettings(currentTabObject.name, this.props);
          currentPlaceholderObj.bedId = currentTabObject.id;
          this.props.updatePlaceholder(currentPlaceholderObj);
          const subProjectInstance = await SubProjectService.saveOrCreateSubProject(subProjectId, config, this.props);
          await SubProjectService.syncAutomationProcess(subProjectInstance, this.props);
          this.props.setCurrentSubProject(subProjectInstance);
        }
      }

      if (this.state.saveAs === SAVE_AS.COPY) {
        projectName = `${project.projectName} copy`;
        projectId = cuid();
        boomFileUrl = '';
        inputFileURL = '';
        outputFileURL = '';
        processingStatus = Project.PROCESSING_STATUS.unsubmitted;
        createdDate = new Date();
      }

      if (processingStatus === Project.PROCESSING_STATUS.copied) {
        processingStatus = Project.PROCESSING_STATUS.unsubmitted;
      }

      if (!this.props.user) {
        console.warn('Unable to save without an instance of auth user');
        return;
      }

      const engineer = `${this.props.user['givenName']} ${this.props.user['surname']}`;

      // Important to note that we cannot affect data touched by immer because is inmutable,
      // So we need to produce a draft
      project = produce(project, (projectDraft) => {
        projectDraft.processingStatus = processingStatus;
        projectDraft.bomFileUrl = boomFileUrl;
      });

      let project_instance = new Project(
        projectId,
        projectName,
        project.engineer || engineer,
        project.city,
        project.state,
        project.country,
        this.props.region.name || project.region,
        this.props.language.name || project.language,
        createdDate,
        project.statusDate || new Date(),
        project.editedDate || null,
        project.processingStatus,
        project.bomFileUrl,
        true,
        '', //workItemId
        inputFileURL, //inputFileURL
        outputFileURL, //outputFileURL
        this.props.projectType,
        project.outputFileURLPipe,
        project.bomFileUrlPipe,
        project.isMultiBedProject ? project.isMultiBedProject : false,
      );

      if (this.state.saveAs === SAVE_AS.COPY && project && project.isMultiBedProject) {
        let otherUser = {};
        if (this.props.multiBed.otherUserId && this.props.multiBed.otherUserId !== null) {
          otherUser['otherUserId'] = this.props.multiBed.otherUserId;
          otherUser['otherUserTokens'] = this.props.multiBed.otherUserTokens;
          this.props.setMultiBedOtherUserData(null, null);
        }

        const beds = this.props.multiBed.beds;
        let idx = 0,
          len = beds.length;
        let newBedsArray = [];

        while (idx < len) {
          const bed = beds[idx];

          await SubProjectService.loadSubProject(bed.id, this.props, false, otherUser)
            .then(async (subProject) => {
              const config = {
                bedName: bed.name,
                parentId: projectId,
                subProject,
                silent: true,
                otherUser,
              };

              // creamos un nuevo proyecto y lo guardamos en silent
              const newSubProjectInstance = await SubProjectService.saveOrCreateSubProject(null, config, this.props);

              await SubProjectService.syncAutomationProcess(
                newSubProjectInstance,
                this.props,
                true,
                subProject,
                otherUser,
              );

              // save payload data for multibed cleaning on array
              const bedMetaData = {
                id: newSubProjectInstance.id,
                name: newSubProjectInstance.projectName,
                oldId: bed.id,
              };
              newBedsArray.push(bedMetaData);
              this.props.updateBedForSaveAs(bedMetaData);
              this.props.setCurrentSubProject(newSubProjectInstance);
            })
            .catch((error) => {
              console.error(`SubProjectService.loadSubProject ${error.message}`);
            });
          idx++;
        }
      }

      let state = this.props.getStateToPersist();

      // testAJV.executeTest(state);

      await project_instance.persistState(state, this.props.user.id, this.props.resourcesTokens.projects.blobToken);

      await project_instance.persist(this.props.user.id, this.props.resourcesTokens.projects.tableToken);

      this.props.setCurrentProject(project_instance);

      const ret = await MiniCADAPI_SEARCH.mergeOrUploadProjectDocument({
        project: project_instance,
        PartitionKey: this.props.user.id,
      });

      /*
      // show barracuda message for USA region only
      if (isFirstSave && this.props.region.id === regionIds.usa) {
        setTimeout(() => {
          this.setState({ showBarracudaDialog: true });
        }, 1000);
      }*/

      toast.success(this.props.content[this.props.lang].projectSaved, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    } catch (error) {
      toast.error(this.props.content[this.props.lang].unableToSaveProject, {
        position: toast.POSITION.TOP_RIGHT,
      });
      console.error(`Error persisting project record ${error.message}`);
    }

    this.setState({
      isSavingProject: false,
      showIsoRowPlusWarning: showIsoRowPlusWarning,
    });
    this.props.setDirtyStateForMultiBeds(false);
    this.props.runSaveProjectAction(false);
    this.closeDialog();

    if (this.state.creatingSave) {
      this.props.resetAppState();
      this.props.switchCreateDialogVisibility(false);
      this.setState({
        creatingSave: false,
      });
    }

    if (this.props.projectType === 'PIPE') {
      setTimeout(async () => await MultiBedService.syncBedsData(this.props.multiBedBeds, this.props), 500);
    }
  }

  isInfoMissing = () => {
    let project = this.props.project || this.props.projectInfo;
    const isInfoMissing =
      project.projectName.trim().length <= 0 ||
      project.city.trim().length <= 0 ||
      (this.props.region.id === regionIds.usa ||
      this.props.region.id === regionIds.canada ||
      this.props.region.id === regionIds.mexico
        ? project.state.trim().length <= 0
        : project.country.trim().length <= 0);
    return isInfoMissing;
  };

  promptSaveAsCurrentDialog = () => {
    this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
    if (this.isInfoMissing()) {
      this.setState({
        hideRequiredFieldsDialog: false,
      });
    } else {
      this.setState({
        saveAs: SAVE_AS.CURRENT,
        dialogConfirmText: this.props.content[this.props.lang].save,
        contentProps: {
          type: DialogType.normal,
          subText: this.props.content[this.props.lang].changesWillOverwrite,
          title: this.props.content[this.props.lang].doYouWantToSaveCurrent,
        },
        hideDialog: false,
      });
    }
  };

  promptSaveAsCopyDialog = () => {
    this.props.clearRulersOnScreen();
    if (this.isInfoMissing()) {
      this.setState({
        hideRequiredFieldsDialog: false,
      });
    } else {
      this.setState({
        saveAs: SAVE_AS.COPY,
        dialogConfirmText: this.props.content[this.props.lang].copy,
        contentProps: {
          type: DialogType.normal,
          subText: this.props.content[this.props.lang].stateSavedAsCopy,
          title: this.props.content[this.props.lang].saveCurrentAsCopy,
        },
        hideDialog: false,
      });
    }
  };

  closeDialog = () => {
    this.setState({
      hideDialog: true,
    });
  };

  closeIsoRowPlusDialog = () => {
    this.setState({
      showIsoRowPlusWarning: false,
    });
  };

  closeBarracudaDialog = () => {
    this.setState({
      showBarracudaDialog: false,
    });
  };

  sendBarracudaEmail = () => {
    this.closeBarracudaDialog();
    MiniCADAPI.sendBarracudaEmail(
      this.props.project.engineer,
      this.props.user.mail,
      this.props.user.id,
      this.props.project.id,
    );
  };

  handleInput = (e) => {
    let newInfo;
    if (this.props.project) {
      newInfo = Object.assign(new Project(), this.props.project);
    } else {
      newInfo = { ...this.props.projectInfo };
    }
    if (e.target.id.includes('Project')) {
      newInfo.projectName = e.target.value;
    }
    if (e.target.id.includes('City')) {
      newInfo.city = e.target.value;
    }
    if (e.target.id.includes('State')) {
      newInfo.state = e.target.value;
    }
    if (e.target.id.includes('Country')) {
      newInfo.country = e.target.value;
    }
    if (this.props.project) {
      this.props.setCurrentProject(newInfo);
    } else {
      this.props.setProjectInfo(newInfo);
    }
  };

  handleCancelCreateOnClick() {
    this.props.switchCreateDialogVisibility(false);
  }

  handleConfirmCreateOnClick(save) {
    if (save) {
      if (this.isInfoMissing()) {
        this.setState({
          hideRequiredFieldsDialog: false,
        });
      } else {
        this.setState({
          saveAs: SAVE_AS.CURRENT,
          isSavingProject: true,
          creatingSave: true,
        });
        this.putCurrentRecord();
      }
    } else {
      this.props.resetAppState();
      this.props.switchCreateDialogVisibility(false);
    }
  }

  handleClick = (e, cb, isButtonDisabled) => {
    if (isButtonDisabled) {
      e.preventDefault();
      this.props.setDisableLayerLoginDialog(true);
    } else {
      // If the button is not "disabled", call the passed callback function
      cb();
    }
  };

  renderProjectButton = (text, cb, styles = {}, disabled) => {
    const isButtonDisabled = !this.props.user || disabled;

    return (
      <DefaultButton
        primary
        text={text}
        // Pass the callback and isButtonDisabled flag to the click handler
        onClick={(e) => this.handleClick(e, cb, isButtonDisabled)}
        style={{
          width: '100%',
          padding: '5px',
          marginTop: '12px',
          ...styles,
        }}
      />
    );
  };

  render() {
    /* the project object, if an instance(persisted is present), otherwise
    use the unsaved project info */
    let project = this.props.project || this.props.projectInfo;

    const { lang, content, isMC4500Deprecated, region } = this.props;

    const renderCalculated = (label, val, id, labelClassName = null) => {
      return (
        <div className="ms-Grid-row" style={{ paddingBottom: '10px' }}>
          <div className={`ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4 ms-xxl4 ${labelClassName || ''}`}>{label}</div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl8 ms-xxl8">
            <TextField
              id={id}
              className={`computedField ${id}`}
              readOnly={false}
              value={val}
              onBlur={(e) => {
                this.handleInput(e);
              }}
            />
          </div>
        </div>
      );
    };

    const renderCalculatedStateColumn = (value, region) => {
      // Apply abbreviations to this mapping
      let options, label, contentLbl;

      if (region === 'usa') {
        options = states;
        contentLbl = content[lang].state;
      } else if (region === 'canada') {
        options = CAProvinces;
        contentLbl = content[lang].province;
      } else if (region === 'mexico') {
        options = MXProvinces;
        contentLbl = content[lang].province;
      } else {
        options = states;
        contentLbl = content[lang].province;
      }
      label = 'State';

      let selectedOption = options.find(
        (state) => state.key.toLowerCase() === value.toLowerCase() || state.text.toLowerCase() === value.toLowerCase(),
      );

      if (value && !selectedOption) {
        selectedOption = { key: value, text: value };
        options.unshift(selectedOption);
      }

      return (
        <div className="ms-Grid-row" style={{ paddingBottom: '10px' }}>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4 ms-xxl4">{contentLbl}</div>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl8 ms-xxl8">
            <Dropdown
              placeholder="Select a state"
              id={label}
              styles={{
                dropdownItemSelected: {
                  color: 'white',
                  backgroundColor: '#0C92CD',
                  selectors: {
                    '&:hover': {
                      color: 'white',
                    },
                  },
                },
                dropdownItem: {
                  selectors: {
                    '&:hover': {
                      color: 'white',
                    },
                  },
                },
              }}
              className={`computedField ${label}`}
              readOnly={false}
              onChange={(event, option) => {
                let newInfo;
                if (this.props.project) {
                  newInfo = Object.assign(new Project(), this.props.project);
                } else {
                  newInfo = { ...this.props.projectInfo };
                }
                newInfo.state = option.text;
                if (this.props.project) {
                  this.props.setCurrentProject(newInfo);
                } else {
                  this.props.setProjectInfo(newInfo);
                }
              }}
              selectedKey={selectedOption ? selectedOption.key : null}
              options={options}
            />
          </div>
        </div>
      );
    };

    const renderStatusField = () => {
      let statusValue = project.processingStatus.includes('failed') ? 'failed' : project.processingStatus;
      return (
        <div className="ms-Grid-row" style={{ paddingBottom: '10px' }}>
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl4 ms-xxl4">{content[lang].status}</div>
          <div
            className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl8 ms-xxl8"
            style={{ ...css.badge, ...css[statusValue] }}>
            {content[lang][statusValue]}
          </div>
        </div>
      );
    };

    const checkForRegion = (state, country, region, regionIds) => {
      const isState = state.length > 0;
      const isCountry = country.length > 0;

      if (region.id === regionIds.usa) {
        return true;
      }
      if (region.id === regionIds.mexico) {
        return true;
      }
      if (region.id === regionIds.canada) {
        if (!isCountry && !isState) {
          return true;
        }
        if (isState) {
          return true;
        }
        if (isCountry) {
          return false;
        }
      }
      if (region.id !== regionIds.usa && region.id !== regionIds.canada && region.id !== regionIds.mexico) {
        return false;
      }
    };

    return (
      <div style={css.card}>
        {project.processingStatus ? renderStatusField() : ''}
        {renderCalculated(content[lang].project, project.projectName, 'Project')}
        {renderCalculated(content[lang].city, project.city, 'City')}
        {checkForRegion(project.state, project.country, this.props.region, regionIds)
          ? renderCalculatedStateColumn(project.state, this.props.region.id, 'State')
          : ''}
        {!checkForRegion(project.state, project.country, this.props.region, regionIds)
          ? renderCalculated(content[lang].countryOrProvince, project.country, 'Country', 'proj-info-country-label')
          : ''}
        {this.renderProjectButton(content[lang].manageProjects, () => {
          this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
          this.props.toggleProjectsCrudModal(true);
        })}
        {(() => {
          try {
            //User is Admin then Show Admin CRUD Table
            console.log(`isInternalUser: ${this.props.resourcesTokens.users.isInternalUser}`);
            if (this.props.resourcesTokens.users.isInternalUser) {

              return this.renderProjectButton(
                content[lang].manageProjectsAdmin,
                () => {
                  this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  this.props.toggleProjectsAdminModal(true);
                },
                css.copied,
              );
            }
          } catch (e) {
            //Hides Admin Crud Button
          }
        })()}
        {(() => {
          if (project.processingStatus === Project.PROCESSING_STATUS.copied) {
            //Disable Save Current Project button when status is copied/unsaved
            return this.renderProjectButton(
              content[lang].saveCurrentProject,
              this.promptSaveAsCurrentDialog,
              { backgroundColor: 'green', color: '#FFF' },
              true,
            );
          } else {
            return this.renderProjectButton(
              content[lang].saveCurrentProject,
              this.promptSaveAsCurrentDialog,
              { backgroundColor: 'green', color: '#FFF' },
              !this.processingStatusIsWritable(project.processingStatus),
            );
          }
        })()}
        {(() => {
          if (this.props.project) {
            return this.renderProjectButton(
              content[lang].saveAsCopy,
              this.promptSaveAsCopyDialog,
              {},
              !this.processingStatusIsWritable(project.processingStatus),
            );
          }
        })()}
        <Dialog
          onDismiss={this.closeDialog}
          hidden={this.state.hideDialog}
          modalProps={this.state.modalProps}
          dialogContentProps={this.state.contentProps}>
          <BlockUi tag="div" className="loadingBlockUI" blocking={this.state.isSavingProject}>
            <DialogFooter>
              <PrimaryButton
                onClick={() => {
                  this.setState({
                    isSavingProject: true,
                  });
                  this.putCurrentRecord();
                }}
                text={this.state.dialogConfirmText}
              />
              <DefaultButton
                onClick={() => this.closeDialog()}
                text={content[lang].cancel}
                className={'outline_grey_ads'}
              />
            </DialogFooter>
          </BlockUi>
        </Dialog>

        <Dialog
          hidden={this.state.hideRequiredFieldsDialog}
          dialogContentProps={this.props.requiredFieldscontentProps}
          modalProps={this.state.requiredFieldsModalProps}
          onDismiss={() => {
            this.setState({
              hideRequiredFieldsDialog: true,
            });
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.setState({
                  hideRequiredFieldsDialog: true,
                });
              }}
              text="Ok"
            />
          </DialogFooter>
        </Dialog>
        <Dialog
          onDismiss={this.closeIsoRowPlusDialog}
          hidden={!this.state.showIsoRowPlusWarning}
          modalProps={{
            containerClassName: 'isoRowPlusWarningContainer',
          }}
          dialogContentProps={{
            type: DialogType.normal,
            showCloseButton: false,
            title: content[lang].isoRowPlusWarningTitle,
            titleId: 'isoRowPlusWarningTitle',
          }}>
          <DialogContent>
            <div
              dangerouslySetInnerHTML={{
                __html: `${content[lang].isoRowPlusWarningTextPart1}<br/><a href="mailto:adsinternational@ads-pipe.com">${content[lang].adsInternationalEmail}</a>&nbsp;${content[lang].isoRowPlusWarningTextPart2}`,
              }}></div>
          </DialogContent>
          <DialogFooter styles={{ textAlign: 'center' }}>
            <DefaultButton onClick={() => this.closeIsoRowPlusDialog()} text={content[lang].ok} />
          </DialogFooter>
        </Dialog>
        <Dialog
          onDismiss={this.closeBarracudaDialog}
          hidden={!this.state.showBarracudaDialog}
          modalProps={{
            containerClassName: 'barracudaMessageContainer',
          }}
          dialogContentProps={{
            type: DialogType.normal,
            showCloseButton: true,
            title: content[lang].barracudaMessageTitle,
            titleId: 'barracudaMessageTitle',
          }}>
          <DialogContent>
            <div dangerouslySetInnerHTML={{ __html: content[lang].barracudaPopupMessage }}></div>
          </DialogContent>
          <DialogFooter styles={{ textAlign: 'center' }}>
            <PrimaryButton
              href="http://bit.ly/StormTechPopUp"
              target="_blank"
              onClick={() => this.closeBarracudaDialog()}
              text={content[lang].takeMeThere}
              className={'secondary_black_ads'}
            />
            <DefaultButton
              onClick={() => this.sendBarracudaEmail()}
              text={content[lang].sendMoreInfo}
              className={'caution_blue_ads'}
            />
          </DialogFooter>
        </Dialog>

        <Dialog
          hidden={!this.props.showCreateDialog}
          dialogContentProps={{
            type: DialogType.normal,
            title: content[lang].createNewProject,
            subText: content[lang].theProjectWillBeCreated,
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}>
          <BlockUi tag="div" className="loadingBlockUI" blocking={this.state.isSavingProject}>
            <DialogFooter>
              <PrimaryButton
                onClick={() => {
                  this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  this.handleConfirmCreateOnClick(true);
                }}
                text={content[lang].yes}
              />
              <DefaultButton
                onClick={() => {
                  this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  this.handleConfirmCreateOnClick(false);
                }}
                text={content[lang].no}
                className={'outline_grey_ads'}
              />
              <DefaultButton
                onClick={() => {
                  this.props.clearRulersOnScreen(); //Clears scale and measurement rulers
                  this.handleCancelCreateOnClick();
                }}
                text={content[lang].cancel}
                className={'outline_grey_ads'}
              />
            </DialogFooter>
          </BlockUi>
        </Dialog>
        <Dialog
          hidden={!this.props.showMultibedSaveWarning}
          dialogContentProps={{
            type: DialogType.normal,
            title: null, // this.props.content[this.props.lang].titleWarning,
            subText: this.props.content[this.props.lang].changesNotSavedOnViewingProjectWarning,
          }}
          modalProps={{
            isBlocking: true,
            containerClassName: 'ms-dialogMainOverride',
          }}
          onDismiss={() => {
            this.props.showProjectsAdminMultibedWarning(false);
          }}>
          <DialogFooter>
            <PrimaryButton
              onClick={() => {
                this.props.showProjectsAdminMultibedWarning(false);
              }}
              text={content[lang].ok}
            />
          </DialogFooter>
        </Dialog>
      </div>
    );
  }
}

const css = {
  card: {
    height: '100%',
    marginTop: '10px',
    marginLeft: '10px',
    marginRight: '10px',
    marginBottom: '10px',
  },
  badge: {
    padding: '5px',
    fontSize: '12pt',
    fontWeight: 'bold',
    textAlign: 'center',
    borderRadius: '5px',
  },
  unsubmitted: {
    color: 'white',
    background: '#112F41',
  },
  pending: {
    color: 'black',
    background: '#F2B134',
  },
  processing: {
    color: 'white',
    background: '#068587',
  },
  failed: {
    color: 'white',
    background: '#ED553B',
  },
  success: {
    color: 'white',
    background: '#4FB99F',
  },
  copied: {
    color: 'black',
    background: '#FFC31B',
  },
};

const mapStateToProps = (state) => {
  return {
    lang: state.localization.lang,
    project: state.project.project,
    subProject: state.subProject,
    user: state.authentication.user,
    content: state.localization.content,
    projectInfo: state.project.projectInfo,
    runSaveProject: state.project.runSaveProject,
    resourcesTokens: state.authentication.resourcesTokens,
    isProjectFromAnotherUsr: state.projectsAdmin.isProjectFromAnotherUsr,
    region: state.localization.region,
    language: state.localization.language,
    requiredFieldscontentProps: {
      type: DialogType.normal,
      title: state.localization.content[state.localization.lang].missingProjectInformation,
      subText:
        state.localization.region.id === regionIds.usa
          ? state.localization.content[state.localization.lang].fieldsRequiredToSave
          : state.localization.content[state.localization.lang].fieldsRequiredToSaveNonUsa,
    },
    isMC4500Deprecated: state.globals.isMC4500Deprecated,
    chamberType: state.globals.chamberType,

    projectType: state.globals.projectType,
    stoneBedPoints: state.stonebed.points,
    chamberbedX: state.chamberbed.x,
    chamberbedY: state.chamberbed.y,
    pipeBedPosition: state.pipeBed.position,
    chamberbedRotation: state.chamberbed.rotation,
    pipeBedRotation: state.pipeBed.rotation,
    chamberbedHeight: state.chamberbed.height,
    chamberbedWidth: state.chamberbed.width,
    pipeBedDimensions: state.pipeBed.dimensions,
    chamberbedScaleX: state.chamberbed.scaleX,
    chamberbedScaleY: state.chamberbed.scaleY,
    pipeGlobals: state.pipeGlobals,
    multiBed: state.multiBed,
    showCreateDialog: state.apptoolbar.showCreateDialog,
    showMultibedSaveWarning: state.projectsAdmin.showMultibedSaveWarning,

    multiBedBeds: state.multiBed.beds,
  };
};

const mapDispatchToProps = {
  setProjectInfo,
  setProjectStatus,
  setCurrentProject,
  getStateToPersist,
  runSaveProjectAction,
  restorePersistedState,
  toggleProjectsCrudModal,
  toggleProjectsAdminModal,
  clearRulersOnScreen,
  modalAlertActions,
  updatePlaceholder,
  getSubProjectStateToPersist,
  getScaledValue,
  clearViewPort,
  setCurrentSubProject,
  clearMainManifoldsState,
  restoreSubProjectPersistedState,
  updateBedForSaveAs,
  setSelectedBed,
  setDirtyStateForMultiBeds,
  buildProjectAutomation,
  buildPipeProjectAutomation,
  setMultiBedOtherUserData,
  getStagePosition,
  getStageScale,
  scaleStage,
  positionStage,
  switchCreateDialogVisibility,
  resetAppState,
  showProjectsAdminMultibedWarning,

  updatedSelectedBedValues,
  setDisableLayerLoginDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectInfoComponent);



// WEBPACK FOOTER //
// ./src/components/LeftMenu/ProjectInfo/project-info.component.js